import { WizardFlowContext } from "../../../wizard-flow-context.model";
import { WizardStepBase } from "../../wizard-step-base.model";
import { StepConfig } from "../step-config.model";

export abstract class StepFactoryBase<TStepConfig extends StepConfig> {
  abstract create(config: TStepConfig, wizardFlowContext: WizardFlowContext): WizardStepBase;
}
